import React, { useState } from 'react';
import { BarChart3, Search, FileDown, Printer, Filter } from 'lucide-react';

const GRCPurchaseDiscountReportScreen = ({ theme }) => {
  const isDark = theme === 'dark';
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <div className={`h-full flex flex-col ${isDark ? 'bg-[#0a0a0a] text-white' : 'bg-gray-50 text-gray-900'}`}>
      {/* Header */}
      <div className={`px-4 py-3 border-b ${isDark ? 'border-gray-800 bg-[#111]' : 'border-gray-200 bg-white'}`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className={`p-2 rounded-lg ${isDark ? 'bg-indigo-500/20' : 'bg-indigo-100'}`}>
              <BarChart3 className="w-5 h-5 text-indigo-500" />
            </div>
            <div>
              <h1 className="text-lg font-bold">GRC Purchase Discount Report</h1>
              <p className={`text-xs ${isDark ? 'text-gray-500' : 'text-gray-500'}`}>Screen ID: 4.12.7</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button className={`px-3 py-1.5 rounded-lg text-xs font-medium flex items-center gap-1.5 ${isDark ? 'bg-blue-600 hover:bg-blue-700' : 'bg-blue-600 hover:bg-blue-700'} text-white`}>
              <Filter size={14} /> Filter
            </button>
            <button className={`px-3 py-1.5 rounded-lg text-xs font-medium flex items-center gap-1.5 ${isDark ? 'bg-green-600 hover:bg-green-700' : 'bg-green-600 hover:bg-green-700'} text-white`}>
              <FileDown size={14} /> Export
            </button>
            <button className={`px-3 py-1.5 rounded-lg text-xs font-medium flex items-center gap-1.5 ${isDark ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-200 hover:bg-gray-300'} ${isDark ? 'text-white' : 'text-gray-700'}`}>
              <Printer size={14} /> Print
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 p-4 overflow-auto">
        <div className={`rounded-lg border ${isDark ? 'border-gray-800 bg-[#111]' : 'border-gray-200 bg-white'} p-4`}>
          <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
            GRC Purchase Discount Report screen - Placeholder for UI implementation as per PDF specifications.
          </p>
        </div>
      </div>
    </div>
  );
};

export default GRCPurchaseDiscountReportScreen;
